import { render, staticRenderFns } from "./ReviewExLearningDetail.vue?vue&type=template&id=585e3cd1&"
import script from "./ReviewExLearningDetail.vue?vue&type=script&lang=js&"
export * from "./ReviewExLearningDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports